// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2Fmm4","file":"styles_file__3f2MC"};